const helpers = require('./helpers')

function setUpGoogleAnalyticsScripts (ga_id) {
  const externalSrc = '//www.google-analytics.com/analytics.js'
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }
  // Side effect of snippet: creates `window.ga`.
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);}, i[r].l = 1 * new Date();a = s.createElement(o),
      m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m)
  })(window, document, 'script', externalSrc, 'ga')

  // Assumes the `window.ga` object is now available.
  if (window.location.hostname === 'localhost') {
    window.ga('create', ga_id, 'none')
  } else {
    window.ga('create', ga_id, 'auto')
  }
  window.ga('require', 'displayfeatures')
}

// https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications#tracking_virtual_pageviews
function firePageTracking (path) {
  window.ga('set', 'page', path)
  window.ga('send', 'pageview')
}

module.exports = {
  setUpGoogleAnalyticsScripts,
  firePageTracking,
}
